import React, { useEffect, useState } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import WidgetCard from './WidgetCard';
import MainCardTitle from './MainCardTitle';
import CenteredSpinner from '../../../components/CenteredSpinner';
import DashboardServices from '../../../services/DashboardServices';

const CaseDistributionByOrganization = ({ title = 'Case distribution by organization' }) => {
    const [loading, setLoading] = useState(true);
    const [organizations, setOrganizations] = useState([]);

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            setLoading(true);
            try {
                const res = await DashboardServices.getDashboardCaseDistributionByOrganization();
                const payload = res?.data ?? res;
                const dataArray = payload?.view?.data ?? payload?.data ?? [];

                const formatted = Array.isArray(dataArray) ? dataArray : [];

                if (mounted) {
                    setOrganizations(formatted);
                }
            } catch (err) {
                console.error('Failed to load case distribution by organization', err);
            } finally {
                if (mounted) setLoading(false);
            }
        };
        load();
        return () => { mounted = false; };
    }, []);

    if (loading) {
        return (
            <WidgetCard sx={{ minHeight: 200 }}>
                <CenteredSpinner />
            </WidgetCard>
        );
    }

    if (organizations.length === 0) {
        return (
            <WidgetCard sx={{ minHeight: 200 }}>
                <MainCardTitle>{title}</MainCardTitle>
                <Typography variant="body2" color="text.secondary" align="center" sx={{ py: 4 }}>
                    No data available
                </Typography>
            </WidgetCard>
        );
    }

    return (
        <WidgetCard sx={{ minHeight: 200 }}>
            <MainCardTitle>{title}</MainCardTitle>
            
            <Box sx={{ 
                display: 'flex', 
                flexWrap: 'wrap',
                gap: 2, 
                mt: 2,
                pb: 1
            }}>
                {organizations.map((org, index) => (
                    <Box
                        key={org.organization_id || index}
                        sx={{
                            minWidth: 150,
                            textAlign: 'center',
                            p: 2,
                            border: '1px solid #e0e0e0',
                            borderRadius: 1,
                            bgcolor: 'background.paper'
                        }}
                    >
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                color: 'text.secondary',
                                fontSize: 14,
                                fontWeight: 500,
                                mb: 1
                            }}
                        >
                            {org.organization_short_name || org.organization_name}
                        </Typography>
                        <Typography 
                            variant="h4" 
                            sx={{ 
                                color: 'primary.main',
                                fontWeight: 600
                            }}
                        >
                            {org.case_count || 0}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </WidgetCard>
    );
};

export default CaseDistributionByOrganization;
